<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/pump-edit/'+selected[0].idpump)"
          >Edit</v-btn>
          <v-btn v-if=" selected.length > 0" text @click="deletePump" color="red">Delete</v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-performance-datas')">
            <v-icon left dark>mdi-chart-line-stacked</v-icon>Performance Datas
          </v-btn>
          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-add')">
            <v-icon left dark>mdi-plus</v-icon>Create Pump
          </v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-types')">
            <v-icon left dark>mdi-folder</v-icon>Pump Types
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          Pumps
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          item-key="idpump"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="pumps"
          :search="search"
        ></v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    selected: [],
    editPumpId: 100,
    search: "",
    pumps: [],
    headers: [
      {
        text: "Type",
        align: "left",
        sortable: true,
        value: "pump_type",
        width: 120
      },

      { text: "Stage", value: "stage" },
      // { text: "Motor", value: "motor_type" },
      { text: "Motor Power 50Hz (HP)", value: "motor_power_50hz" },
      { text: "Motor Power 60Hz (HP)", value: "motor_power_60hz" },
      { text: "Material", value: "material", width: 150 },
      // { text: "P2", value: "p2" },
      // { text: "Max Shaft Power", value: "max_shaft_power" },
      // { text: "A", value: "a" },
      // { text: "B", value: "b" },
      { text: "Length (mm)", value: "c" },
      // { text: "Fi_D", value: "fi_d" },
      // { text: "Fi_e (inch)", value: "fi_e" },
      { text: "Weight (kg)", value: "weight" },
      { text: "Price ($)", value: "price" }
    ],

    pump: {
      idpump: -1,
      model: "XSP 20",
      material: "Stainless Steel",
      price: "",
      motorid: "10",
      nominal_diameter: "6",
      stage: 50,
      max_shaft_power: 100,
      p2: 70,
      diameter_outlet: 40,
      weight: 6,
      lp: 65
    }
  }),
  mounted: function() {
     if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchPumps();
  },
  methods: {
    deletePump: function() {
      confirm("Are you sure you want to delete this item?") &&
        this.selected.forEach(this.deletePumpRequest);
      this.selected = [];
      console.log("selected bosaltildi.");
    },
    deletePumpRequest: function(pump) {
      this.$http
        .get(this.$API_URL + "pump-delete?idpump=" + pump.idpump)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchPumps();
        });
    },
    fetchPumps: function() {
      this.$http.get(this.$API_URL + "pumps").then(result => {
        this.pumps = result.data;
      });
    }
  }
};
</script>
